import { HStack, Heading, Icon, SimpleGrid, VStack } from "@chakra-ui/react";
import { CirclesFour, Student } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import BlogMenuItem from "../components/blogComponents/BlogMenuItem";
import NavHeader from "../components/NavHeader";

export default function Course() {
  return (
    <>
      <NavHeader label="Course" />

      <VStack flex={1} align={"stretch"} p={5}>
        <SimpleGrid columns={[1, 2, 3, null, 4]} color={"white"} gap={4}>
          <BlogMenuItem
            border={"2px solid var(--p500)"}
            color={"p.500"}
            _hover={{ bg: "p.500", color: "white" }}
            as={Link}
            to={"/course/list"}
          >
            <HStack>
              <Icon as={Student} fontSize={50} weight="fill" />
            </HStack>

            <Heading size={"md"}>COURSE LIST</Heading>
          </BlogMenuItem>

          <BlogMenuItem
            border={"2px solid #805AD5"}
            color={"purple.500"}
            _hover={{ bg: "purple.500", color: "white" }}
            as={Link}
            to={"/course/tema"}
          >
            <HStack>
              <Icon as={CirclesFour} fontSize={50} weight="fill" />
            </HStack>

            <Heading size={"md"}>TEMA</Heading>
          </BlogMenuItem>

          {/* <BlogMenuItem
            border={"2px solid black"}
            color="black"
            _hover={{ bg: "black", color: "white" }}
            as={Link}
            to={"/course/pengguna"}
          >
            <HStack>
              <Icon as={UsersThree} fontSize={50} weight="fill" />
            </HStack>

            <Heading size={"md"}>DASHBOARD</Heading>
          </BlogMenuItem> */}
        </SimpleGrid>
      </VStack>
    </>
  );
}
